/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Users_Price_MonthlyInputs */



/**
* | output |
* | --- |
* | "$10/month" |
*
* @param {Team_Manager_Add_Users_Price_MonthlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_users_price_monthly = /** @type {((inputs?: Team_Manager_Add_Users_Price_MonthlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Users_Price_MonthlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("10 $/mois")
	if (locale === "de") return /** @type {LocalizedString} */ ("10 $/Monat")
	if (locale === "it") return /** @type {LocalizedString} */ ("10 $/mese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("$10/мес.")
	if (locale === "es") return /** @type {LocalizedString} */ ("10 $/mes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每月 10 美元")
	if (locale === "ja") return /** @type {LocalizedString} */ ("月額 $10")
	if (locale === "hi") return /** @type {LocalizedString} */ ("$10/माह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("10 $/mês")
	return /** @type {LocalizedString} */ ("$10/month")
});